export default __webpack_public_path__ + "static/media/media_forward_30.402ed054.svg";